const SearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Item",
                "tableName": "",
                "label": "Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "location",
                "tableName": "",
                "label": "Location",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ItemDescription",
                "tableName": "",
                "label": "Item Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "LocationDescription",
                "tableName": "",
                "label": "Location Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Lot",
                "tableName": "",
                "label": "Lot",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Warehouse",
                "tableName": "",
                "label": "Warehouse",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "LotDescription",
                "tableName": "",
                "label": "Lot Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Unit",
                "tableName": "",
                "label": "Unit",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 5,
        "label": "",
        "fields": [
            {
                "name": "Sublot",
                "tableName": "",
                "label": "SubLot",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Customer",
                "tableName": "",
                "label": "Customer",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 6,
        "label": "",
        "fields": [
            {
                "name": "InTransactionNumber",
                "tableName": "",
                "label": "Lot First Receipt Transaction",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    }

];
    export default SearchFormLayout;